import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Cake, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const LifeDatesSync = ({ uid, onDone }) => {
  const [job, setJob] = useState(null);
  const timer = useRef(null);
  const poll = async () => {
    let data;
    try { ({ data } = await api.get(`/universes/${uid}/life-dates/sync`)); } catch (e) { toast.error(errMsg(e)); setJob(null); return; }
    setJob(data);
    if (data.status === "running") timer.current = setTimeout(poll, 1500);
    else if (data.status === "done") {
      onDone?.();
      toast.success(data.total ? `Synced ${data.total} entr${data.total === 1 ? "y" : "ies"}: ${data.placed} date${data.placed === 1 ? "" : "s"} placed${data.unplaced ? `, ${data.unplaced} couldn't be placed` : ""}` : "No birth or death dates found in your entries");
    }
  };
  useEffect(() => () => clearTimeout(timer.current), []);
  const start = async () => {
    try { setJob((await api.post(`/universes/${uid}/life-dates/sync`)).data); timer.current = setTimeout(poll, 1200); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const running = job?.status === "running";
  return (
    <Button variant="ghost" onClick={start} disabled={running} title="Add every Birth date and Death date field to your timelines and calendars" data-testid="sync-life-dates-button">
      {running ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Cake className="mr-1.5 h-4 w-4" />}
      {running ? `Syncing ${job.done}/${job.total || "…"}` : "Sync birth dates"}
    </Button>
  );
};
